function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "trophy1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 41 200 L 147 200 L 147 224.9375 L 41 224.9375 Z M 41 200 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "trophy2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 155.230469 24 L 184.796875 24 L 184.796875 105 L 155.230469 105 Z M 155.230469 24 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "trophy3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 26 0.0585938 L 159 0.0585938 L 159 165 L 26 165 Z M 26 0.0585938 "
})));

function SvgTrophyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "26px",
    viewBox: "0 0 224.87999 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "trophyicon"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(97.648621%,65.879822%,14.509583%)",
      fillOpacity: 1
    },
    d: "M 71.503906 155.480469 L 71.503906 214.671875 L 113.441406 214.671875 L 113.441406 155.480469 C 106.730469 157.609375 99.671875 158.722656 92.472656 158.722656 C 85.273438 158.722656 78.214844 157.609375 71.503906 155.480469 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trophy1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078491%,49.798584%,9.01947%)",
      fillOpacity: 1
    },
    d: "M 53.40625 200.082031 L 134.128906 200.082031 C 137.484375 200.082031 140.535156 201.457031 142.746094 203.675781 C 144.953125 205.886719 146.324219 208.945312 146.324219 212.3125 L 146.324219 227.558594 L 41.210938 227.558594 L 41.210938 212.3125 C 41.210938 208.945312 42.582031 205.886719 44.789062 203.675781 C 46.996094 201.457031 50.046875 200.082031 53.40625 200.082031 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trophy2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.648621%,65.879822%,14.509583%)",
      fillOpacity: 1
    },
    d: "M 155.972656 24.316406 L 180.882812 24.316406 C 183.046875 24.316406 184.800781 26.078125 184.800781 28.246094 L 184.800781 68.445312 C 184.800781 78.59375 180.664062 87.816406 173.996094 94.503906 C 169.066406 99.441406 162.753906 103 155.707031 104.519531 C 155.886719 102.5 155.972656 100.46875 155.972656 98.425781 L 155.972656 24.316406 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.648621%,65.879822%,14.509583%)",
      fillOpacity: 1
    },
    d: "M 4.066406 24.316406 L 29.097656 24.316406 L 29.097656 98.425781 C 29.097656 100.476562 29.191406 102.519531 29.363281 104.542969 C 22.269531 103.042969 15.90625 99.472656 10.949219 94.503906 C 4.28125 87.816406 0.144531 78.59375 0.144531 68.445312 L 0.144531 28.246094 C 0.144531 26.078125 1.898438 24.316406 4.066406 24.316406 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trophy3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.429871%,75.289917%,17.649841%)",
      fillOpacity: 1
    },
    d: "M 154.566406 0.0585938 L 30.378906 0.0585938 C 28.21875 0.0585938 26.464844 1.820312 26.464844 3.988281 L 26.464844 98.425781 C 26.464844 116.628906 33.886719 133.179688 45.847656 145.175781 C 57.8125 157.171875 74.316406 164.613281 92.472656 164.613281 C 110.628906 164.613281 127.132812 157.171875 139.097656 145.175781 C 151.058594 133.179688 158.480469 116.628906 158.480469 98.425781 L 158.480469 3.988281 C 158.480469 1.820312 156.726562 0.0585938 154.566406 0.0585938 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,99.21875%,90.589905%)",
      fillOpacity: 1
    },
    d: "M 101.671875 72.371094 L 96.285156 55.636719 C 95.980469 54.347656 95.027344 53.238281 93.675781 52.804688 C 91.617188 52.136719 89.40625 53.269531 88.742188 55.335938 L 88.753906 55.34375 L 83.273438 72.371094 L 65.777344 72.335938 C 64.449219 72.214844 63.085938 72.78125 62.246094 73.945312 C 60.980469 75.703125 61.375 78.160156 63.125 79.429688 L 63.128906 79.429688 L 77.585938 89.914062 L 72.113281 106.683594 C 71.636719 107.894531 71.769531 109.320312 72.589844 110.453125 C 73.863281 112.203125 76.316406 112.589844 78.066406 111.308594 L 78.050781 111.296875 L 92.472656 100.746094 L 106.589844 111.070312 C 107.59375 111.96875 109.039062 112.320312 110.410156 111.867188 C 112.464844 111.195312 113.585938 108.976562 112.914062 106.914062 L 112.90625 106.914062 L 107.363281 89.914062 L 121.640625 79.554688 C 122.726562 78.855469 123.445312 77.632812 123.441406 76.242188 C 123.4375 74.074219 121.679688 72.316406 119.515625 72.320312 L 119.515625 72.335938 L 101.671875 72.371094 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/TrophyIcon.c5831978.svg";
export { ForwardRef as ReactComponent };